module.exports = __webpack_public_path__ + "img/third.f2f08c74.png";